<!--
  * name: Product
  * description: [Main] Product 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="products"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <top-area /> <!-- 제목 비주얼 -->
    <list /> <!-- 결과 영역 -->
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import TopArea from './partial/TopArea.vue';
import List from './partial/List.vue';

export default {
  name: 'Product',
  components: {
    BreadCrumb,
    TopArea,
    List,
  },
};
</script>

<style lang='scss' scoped>
.breadcrum{
  color: white;
  /deep/ .breadcrum-firstLink{
    color: white;
  }
}
</style>
